import SectionResults from './sectionResults.js';
export default SectionResults;
